// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comentar-no-chamado-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 8px;
    background-color: var(--branco-padrao);
    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);
}

.conteudo-comentario-chamado {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: max-content;
}

.conteudo-comentario {
    width: 100%;
    border: none;
    outline: none;
    background-color: var(--fundo-input2);
    font-size: 1rem;
    padding: .7rem 1rem;
    resize: none;
    border-radius: 8px 8px 0 0;
    height: 6rem;
    white-space: pre-wrap;
}

.extras-container-comentario-chamado {
    display: flex;
    width: 100%;
    padding: .5rem .5rem;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 8px 8px;
    background-color: var(--cinza-claro);
    border-left: 1px solid var(--cinza-fundo-input-padrao);
    border-right: 1px solid var(--cinza-fundo-input-padrao);
    border-bottom: 1px solid var(--cinza-fundo-input-padrao);
}

.botao-comentar-chamado {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.3rem;
    width: 12rem;
}

.anexos-e-adicionais-container {
    display: flex;
    background: var(--branco-interior-modais);
    border-bottom: solid 1px var(--fundo-input2);
    border-left: solid 1px var(--fundo-input2);
    border-right: solid 1px var(--fundo-input2);
    border-radius: 0 0 8px 8px;
    padding: .5rem .7rem;
    gap: .5rem;
    justify-content: space-between;
}

.anexos-e-adicionais-container label {
    font-size: 1.2rem;
}

.input-file-label {
    cursor: pointer;
    transition: all .3s ease-in-out;
    padding: .3rem;
}

.input-file-label:hover {
    color: var(--azul-dixi);
    background-color: var(--botao-hover-clarinho);
    border-radius: 5px;
}

.container-selecionar-arquivos {
    display: flex;
    gap: .5rem;
}

.imagens-adicionadas-pelo-usuario-coment {
    position: absolute;
    display: flex;
    gap: .7rem;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
}

.container-input-chamado {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 600;
    font-size: .8rem;
    color: var(--text-color2);
}

.container-imagem-selecionada {
    position: relative;
}

.container-imagem-selecionada svg {
    position: absolute;
    top: 0;
    right: 0;
    color: var(--vermelho-padrao);
    background-color: var(--branco-padrao);
    border-radius: 50%;
    transition: all .15s ease-in-out;
    cursor: pointer;
}

.container-imagem-selecionada svg:hover {
    color: var(--branco-padrao);
    background-color: var(--vermelho-padrao);
}

.imagens-adicionadas-pelo-usuario, .imagem-selecionada-pelo-usuario-chamado {
    min-width: 60px;
    min-height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 5px;
    object-fit: cover;
    pointer-events: none;
}

.informacoes-anexos-adicionados {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.informacoes-anexos-adicionados .quantidade-arquivos-adicionados {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;
    background-color: var(--azul-desativado);
    color: var(--texto-azul);
    min-width: max-content;
    padding: 0 .2rem;
    min-width: 1.2rem;
    height: 1.4rem;
    border-radius: 3px;
}

.informacoes-anexos-adicionados .textos-arquivos-adicionados {
    font-weight: 600;
    color: var(--cinza-label-input-padrao);
    font-size: .8rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ComentarioChamado/ComentarioChamado.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;IAC1B,oCAAoC;IACpC,sDAAsD;IACtD,uDAAuD;IACvD,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,4CAA4C;IAC5C,0CAA0C;IAC1C,2CAA2C;IAC3C,0BAA0B;IAC1B,oBAAoB;IACpB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,6BAA6B;IAC7B,sCAAsC;IACtC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB","sourcesContent":[".comentar-no-chamado-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 1rem;\n    padding: 1rem;\n    border-radius: 8px;\n    background-color: var(--branco-padrao);\n    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);\n}\n\n.conteudo-comentario-chamado {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n    height: max-content;\n}\n\n.conteudo-comentario {\n    width: 100%;\n    border: none;\n    outline: none;\n    background-color: var(--fundo-input2);\n    font-size: 1rem;\n    padding: .7rem 1rem;\n    resize: none;\n    border-radius: 8px 8px 0 0;\n    height: 6rem;\n    white-space: pre-wrap;\n}\n\n.extras-container-comentario-chamado {\n    display: flex;\n    width: 100%;\n    padding: .5rem .5rem;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 0 0 8px 8px;\n    background-color: var(--cinza-claro);\n    border-left: 1px solid var(--cinza-fundo-input-padrao);\n    border-right: 1px solid var(--cinza-fundo-input-padrao);\n    border-bottom: 1px solid var(--cinza-fundo-input-padrao);\n}\n\n.botao-comentar-chamado {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 2.3rem;\n    width: 12rem;\n}\n\n.anexos-e-adicionais-container {\n    display: flex;\n    background: var(--branco-interior-modais);\n    border-bottom: solid 1px var(--fundo-input2);\n    border-left: solid 1px var(--fundo-input2);\n    border-right: solid 1px var(--fundo-input2);\n    border-radius: 0 0 8px 8px;\n    padding: .5rem .7rem;\n    gap: .5rem;\n    justify-content: space-between;\n}\n\n.anexos-e-adicionais-container label {\n    font-size: 1.2rem;\n}\n\n.input-file-label {\n    cursor: pointer;\n    transition: all .3s ease-in-out;\n    padding: .3rem;\n}\n\n.input-file-label:hover {\n    color: var(--azul-dixi);\n    background-color: var(--botao-hover-clarinho);\n    border-radius: 5px;\n}\n\n.container-selecionar-arquivos {\n    display: flex;\n    gap: .5rem;\n}\n\n.imagens-adicionadas-pelo-usuario-coment {\n    position: absolute;\n    display: flex;\n    gap: .7rem;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n}\n\n.container-input-chamado {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-weight: 600;\n    font-size: .8rem;\n    color: var(--text-color2);\n}\n\n.container-imagem-selecionada {\n    position: relative;\n}\n\n.container-imagem-selecionada svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    color: var(--vermelho-padrao);\n    background-color: var(--branco-padrao);\n    border-radius: 50%;\n    transition: all .15s ease-in-out;\n    cursor: pointer;\n}\n\n.container-imagem-selecionada svg:hover {\n    color: var(--branco-padrao);\n    background-color: var(--vermelho-padrao);\n}\n\n.imagens-adicionadas-pelo-usuario, .imagem-selecionada-pelo-usuario-chamado {\n    min-width: 60px;\n    min-height: 60px;\n    max-width: 60px;\n    max-height: 60px;\n    border-radius: 5px;\n    object-fit: cover;\n    pointer-events: none;\n}\n\n.informacoes-anexos-adicionados {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.informacoes-anexos-adicionados .quantidade-arquivos-adicionados {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1rem;\n    font-weight: 600;\n    background-color: var(--azul-desativado);\n    color: var(--texto-azul);\n    min-width: max-content;\n    padding: 0 .2rem;\n    min-width: 1.2rem;\n    height: 1.4rem;\n    border-radius: 3px;\n}\n\n.informacoes-anexos-adicionados .textos-arquivos-adicionados {\n    font-weight: 600;\n    color: var(--cinza-label-input-padrao);\n    font-size: .8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
